import axios from "axios";
import { urlAPI } from "../../config/config";
import { showSnackbar } from "../../redux/actions";
import { IRegieBaremeHistoryEntry } from "../../interface/regie";

export const getRegieBaremeHistory = async (
  token: string,
  setHistory: (history: IRegieBaremeHistoryEntry[]) => void,
  dispatch: Function,
  setError: Function
) => {
  try {
    const response = await axios.get(`${urlAPI}/regie/baremes/history`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    setHistory(response.data.message);
  } catch (error: any) {
    console.error(error);
    setError("Impossible de récupérer l'historique des barèmes régie.");
    dispatch(showSnackbar("Erreur lors du chargement de l'historique des barèmes régie.", "error"));
  }
};
